import React from 'react';
import { Button } from '@medely/ui-kit';
import useDialog from '@mp/hooks/useDialog';
import { PositionsDetailsModal } from '../../../../../components/positionsDetailsModal/PositionsDetailsModal';
import { IPosition } from '@medely/types';

export type PositionsDetailsModalButtonProps = {
  positions: IPosition[];
};

export const PositionsDetailsModalButton = ({ positions }: PositionsDetailsModalButtonProps) => {
  const { open, openDialog, closeDialog } = useDialog();

  return (
    <>
      <Button variant="text" onClick={() => openDialog()} testId="positions-details-modal-button">
        Learn more about each position
      </Button>
      <PositionsDetailsModal positions={positions} open={open} onClose={closeDialog} />
    </>
  );
};
